let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eleM6")).then(() => parcelRequire('eO2lu'));